import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import React from 'react';
import { colours } from 'utils/constants';

const CustomToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 10,
  border: `1px solid ${theme.palette.grey[300]}`,
  overflow: 'hidden'
}));

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  fontSize: 16,
  color: 'black',
  '&.MuiToggleButton-root': {
    borderRadius: 0,
    padding: '4px 20px 4px 20px'
  },
  '&.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: colours.seafoam,
    '&:hover': {
      backgroundColor: colours.seafoam
    }
  },
  '&:first-of-type': {
    borderRadius: `50px`,
    borderColor: 'transparent'
  },
  '&:last-of-type': {
    borderRadius: `50px`,
    borderColor: 'transparent'
  }
}));

type ToggleSwitchProps = {
  option1: string;
  option2: string;
  selectedOption: string;
  onChange: (selected: string) => void;
  option1Tooltip?: string;
  option2Tooltip?: string;
};

export default function ToggleSwitch({
  option1,
  option2,
  selectedOption,
  onChange,
  option1Tooltip,
  option2Tooltip
}: ToggleSwitchProps) {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <CustomToggleButtonGroup value={selectedOption} exclusive onChange={handleChange}>
      <Tooltip title={option1Tooltip ?? ''}>
        <div>
          <CustomToggleButton value={option1}>{_.capitalize(option1)}</CustomToggleButton>
        </div>
      </Tooltip>
      <Tooltip title={option2Tooltip ?? ''}>
        <div>
          <CustomToggleButton value={option2}>{_.capitalize(option2)}</CustomToggleButton>
        </div>
      </Tooltip>
    </CustomToggleButtonGroup>
  );
}
